var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5465 3H11.0581C6.60775 3 3 6.6097 3 11.0625V32.5625C3 37.0153 6.60775 40.625 11.0581 40.625H32.5465C36.9969 40.625 40.6047 37.0153 40.6047 32.5625V11.0625C40.6047 6.6097 36.9969 3 32.5465 3Z",
    fill: "url(#paint0_radial_750_6043)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5465 3H11.0581C6.60775 3 3 6.6097 3 11.0625V32.5625C3 37.0153 6.60775 40.625 11.0581 40.625H32.5465C36.9969 40.625 40.6047 37.0153 40.6047 32.5625V11.0625C40.6047 6.6097 36.9969 3 32.5465 3Z",
    fill: "url(#paint1_radial_750_6043)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0714 3H10.9286C6.54974 3 3 6.54974 3 10.9286V32.0714C3 36.4503 6.54974 40 10.9286 40H32.0714C36.4503 40 40 36.4503 40 32.0714V10.9286C40 6.54974 36.4503 3 32.0714 3Z",
    fill: "url(#paint2_radial_750_6043)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2009 14.4219C31.2009 15.535 30.299 16.4375 29.1864 16.4375C28.0738 16.4375 27.1719 15.535 27.1719 14.4219C27.1719 13.3087 28.0738 12.4062 29.1864 12.4062C30.299 12.4062 31.2009 13.3087 31.2009 14.4219Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8011 28.5312C25.5097 28.5312 28.5162 25.5231 28.5162 21.8125C28.5162 18.1019 25.5097 15.0938 21.8011 15.0938C18.0924 15.0938 15.0859 18.1019 15.0859 21.8125C15.0859 25.5231 18.0924 28.5312 21.8011 28.5312ZM21.8011 25.8438C24.0263 25.8438 25.8301 24.039 25.8301 21.8125C25.8301 19.586 24.0263 17.7812 21.8011 17.7812C19.5758 17.7812 17.772 19.586 17.772 21.8125C17.772 24.039 19.5758 25.8438 21.8011 25.8438Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37109 21.275C8.37109 16.7596 8.37109 14.5018 9.24938 12.7772C10.0219 11.2601 11.2547 10.0267 12.7709 9.25376C14.4946 8.375 16.7512 8.375 21.2641 8.375H22.3385C26.8515 8.375 29.108 8.375 30.8317 9.25376C32.348 10.0267 33.5807 11.2601 34.3532 12.7772C35.2316 14.5018 35.2316 16.7596 35.2316 21.275V22.35C35.2316 26.8654 35.2316 29.1232 34.3532 30.8477C33.5807 32.3648 32.348 33.5983 30.8317 34.3712C29.108 35.25 26.8515 35.25 22.3385 35.25H21.2641C16.7512 35.25 14.4946 35.25 12.7709 34.3712C11.2547 33.5983 10.0219 32.3648 9.24938 30.8477C8.37109 29.1232 8.37109 26.8654 8.37109 22.35V21.275ZM21.2641 11.0625H22.3385C24.6394 11.0625 26.2034 11.0646 27.4123 11.1634C28.59 11.2597 29.1923 11.4342 29.6124 11.6483C30.6231 12.1637 31.4449 12.9859 31.96 13.9973C32.174 14.4176 32.3485 15.0201 32.4447 16.1984C32.5434 17.4081 32.5455 18.9729 32.5455 21.275V22.35C32.5455 24.6521 32.5434 26.2169 32.4447 27.4266C32.3485 28.6049 32.174 29.2074 31.96 29.6277C31.4449 30.6391 30.6231 31.4613 29.6124 31.9766C29.1923 32.1908 28.59 32.3654 27.4123 32.4616C26.2034 32.5604 24.6394 32.5625 22.3385 32.5625H21.2641C18.9633 32.5625 17.3993 32.5604 16.1903 32.4616C15.0126 32.3654 14.4104 32.1908 13.9903 31.9766C12.9795 31.4613 12.1577 30.6391 11.6427 29.6277C11.4286 29.2074 11.2542 28.6049 11.158 27.4266C11.0592 26.2169 11.0571 24.6521 11.0571 22.35V21.275C11.0571 18.9729 11.0592 17.4081 11.158 16.1984C11.2542 15.0201 11.4286 14.4176 11.6427 13.9973C12.1577 12.9859 12.9795 12.1637 13.9903 11.6483C14.4104 11.4342 15.0126 11.2597 16.1903 11.1634C17.3993 11.0646 18.9633 11.0625 21.2641 11.0625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_750_6043",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4302 31.2188) rotate(-55.3903) scale(34.286 34.2794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_750_6043",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0872 41.9688) rotate(-65.1481) scale(30.3581 30.3474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_750_6043",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.01786 4.32143) rotate(-8.1301) scale(51.3915 10.9921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagramlogo.4146be29043d491e1b72af8a86708bd6.svg";
export { ForwardRef as ReactComponent };